import { FastTagType } from "common/clients/fastTag/FastTagType";
import { AdSetsSync } from "tags/facebook/common/AdSetsSync/AdSetsSync";

export const editAdSetsSyncPage = {
  fastTag: FastTagType.FACEBOOK,
  type: "step",
  id: "edit-ad-sets-sync",
  component: AdSetsSync,
} as const;
